import settings from '../settings.json';

const itemKey = '__trp_appState';

// we do not want to use localStorage except in dev
export const persistState = appState =>
  settings.useLocalStorage &&
  window.localStorage.setItem(itemKey, JSON.stringify(appState));

// we do not want to use localStorage except in dev
export const getState = () => {
  if (!settings.useLocalStorage) return false;
  const stateString = window.localStorage.getItem(itemKey);
  return stateString && JSON.parse(stateString);
};
